// extracted by mini-css-extract-plugin
module.exports = {"header":"SimpleHeader_header__TohDb","mobile-header":"SimpleHeader_mobile-header__Qxx61"};